<template>
  <div class="tab-content">
    <el-row>
      <div style="text-align:right" v-if="dataLoaded">
        <!-- {{form.marketIds}} -->
        <label>{{t_content('botApp.tab03.importMarket.label')}}</label>
        <el-tooltip :content="t_content('botApp.tab03.importMarket.tooltip')" placement="top" effect="light">
          <i class="el-icon-question"></i>
        </el-tooltip>
        <el-dropdown size="mini" split-button trigger="click" @command="importCommand"
        :class="(!applyStatus.page.tab03.enable)?'app-lock':''">
          <span class="el-dropdown-link">{{t_content('botApp.tab03.importMarket.selector')}}</span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              v-for="market in availableMarkets"
              :key="market.lang"
              :command="market.lang"
            >{{ $t('botApp.' + market.name) }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>

      <hr>
      <div class="langTabs" v-if="dataLoaded" :key="tabsKey">
        <el-tabs type="card" v-model="currTabName" @tab-click="handleTabClick">
          <el-tab-pane
            v-for="(market,index) in availableMarketsSel"
            :label="market.miboStoreMarketId.toString()"
            :key="index"
            :name="market.name"
          >
            <span slot="label">{{ $t('botApp.' + market.name) }}</span>
            <market-form
              :form="displayMarket(market.lang)"
              :class="(!applyStatus.page.tab03.enable)?'app-lock':''"
              ref="market"
            />
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-row>
  </div>
</template>

<script>
import api from '../../../api'
import apiConfig from '../../../api/apiConfig'
import MarketForm from './tab03/marketForm'
import _ from 'lodash'

export default {
    mounted () {
        let vm = this
        vm.pubLangOptions()
        vm.$root.$on('updateMarketIds', marketIds => {
            vm.form.marketIds = marketIds
            if (marketIds.length > 0) {
                let marketName = this.getMarketNamebyId(marketIds[0])
                vm.currTabName = marketName
            }
        })
    },
    data () {
        let { candidate, marketIds } = this.appInfo
        return {
            tabsKey: '0000001',
            form: {
                marketIds,
                candidate
            },
            marketList: [],
            currTabName: '', // activeTab Name
            addMarketId: '',
            dataLoaded: false
        }
    },
    props: ['appInfo', 'applyStatus'],
    components: {
        'market-form': MarketForm
    },
    methods: {
        t_content (tKey) {
            return this.$t(tKey, {
                contentType: this.$t(`botApp.${this.$store.state.contentType}`)
            })
        },
        importCommand (srcLangCode) {
            let vm = this
            vm.$confirm(
                this.t_content('botApp.tab03.marketImport.dialog.msg'),
                this.t_content('botApp.tab03.marketImport.dialog.title'),
                {
                    confirmButtonText: this.t_content('botApp.tab03.marketImport.dialog.ok'),
                    cancelButtonText: this.t_content('botApp.tab03.marketImport.dialog.cancel'),
                    type: 'warning'
                }
            )
                .then(() => {
                    let toLangCode = vm.getMarketLangCodebyName(vm.currTabName)
                    vm.copyMarket(srcLangCode, toLangCode)
                    vm.tabsKey = Math.random().toString(36).substring(7)
                })
                .catch(() => {

                })
        },
        getDataFromChild () {
            this.form.candidate = _.map(this.$refs['market'], o => {
                return o.getDataFromChild()
            })
            return this.form
        },
        handleSetTemplate () {
            const cName = this.t_content('botApp.' + this.currTabName)
            // this.form.mainMarket = this.getMarketIdbyName(this.currTabName)
            this.$message({
                message: this.t_content('botApp.tab03.setTemplate.msg', {
                    marketName: cName
                }),
                type: 'success'
            })
        },
        handleNewMarket (marketId) {
            if (this.form.marketIds.indexOf(marketId) > -1) return
            this.form.marketIds.push(marketId)

            let marketName = this.getMarketNamebyId(marketId)
            this.currTabName = marketName
            this.addMarketId = '' // clear.
        },
        displayMarket (langCode) {
            let can = _.find(this.form.candidate, { langCode })
            if (!can) {
                this.addMarket(langCode)
                if (this.form.candidate.length === 1) {
                    this.form.candidate[0].title = this.$route.query.title
                }
                can = _.find(this.form.candidate, { langCode })
            }
            return can
        },
        handleTabClick (tab) {},
        pubLangOptions () {
            // const { title, message, status, publishAfterDate } = this
            const apiUri = 'developer/market'
            const apiCfg = apiConfig(apiUri)
            // let body = { ...this.form }

            api.request('get', apiCfg.path, null, null, apiCfg.headers)
                .then(response => {
                    this.marketList = response.data.data.payload
                    if (this.form.candidate.length > 0) {
                        this.currTabName = this.getMarketNamebyLang(
                            this.form.candidate[0].langCode
                        )
                    }
                    this.dataLoaded = true
                })
                .catch(error => {
                    console.log(error)
                })
        },
        copyMarket (srcLangCode, langCode) {
            let srcCan = _.find(
                this.form.candidate,
                o => o.langCode === srcLangCode
            )
            let toCan = _.find(
                this.form.candidate,
                o => o.langCode === langCode
            )
            _.assign(toCan, srcCan)
            toCan.langCode = langCode
        },
        addMarket (langCode) {
            this.form.candidate.push({
                title: '',
                desc: '',
                tag: '',
                slogan: '',
                langCode,
                function: [],
                keyword: [],
                icons: [],
                screenshot: [],
                // promotion: [],
                videoUrl: '',
                isDefault: ''
            })
        },
        marketSort (mkts, headId) {
            const idx = mkts.findIndex(obj => obj.miboStoreMarketId === headId)
            mkts.push(...mkts.splice(0, idx))
            return mkts
        },
        getMarketIdbyName (name) {
            return _.find(this.marketList, { name }).miboStoreMarketId
        },
        getMarketNamebyId (miboStoreMarketId) {
            return _.find(this.marketList, { miboStoreMarketId }).name
        },
        getMarketbyId (miboStoreMarketId) {
            return _.find(this.marketList, { miboStoreMarketId })
        },
        getMarketNamebyLang (lang) {
            return _.find(this.marketList, { lang }).name
        },
        getMarketLangCodebyName (name) {
            return _.find(this.marketList, { name }).lang
        }
    },
    computed: {
        availableMarkets () {
            return this.availableMarketsSel.filter(market => {
                return market.name !== this.currTabName
            })
        },
        availableMarketsSel () {
            if (!this.marketList) return []
            return _.map(this.form.marketIds, mid => {
                return _.find(this.marketList, m => m.miboStoreMarketId === mid)
            })
        }
    }
}
</script>

<style lang="scss">
.marketChoose {
    .el-icon-arrow-up:before {
        content: '\E62B';
        font-weight: bolder;
        color: black;
    }
    .el-input__inner,
    .el-input__inner::placeholder,
    .el-select .el-input__inner:focus {
        border: none;
        background-color: transparent;
        color: black;
        width: 140px;
    }
    .el-select .el-input .el-select__caret {
        transform: none;
    }
}
</style>
